"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeavrAuthorizationTypesEnum = void 0;
var WeavrAuthorizationTypesEnum;
(function (WeavrAuthorizationTypesEnum) {
    WeavrAuthorizationTypesEnum["AUTHORISED"] = "AUTHORISED";
    WeavrAuthorizationTypesEnum["DECLINED"] = "DECLINED";
    WeavrAuthorizationTypesEnum["ONLINE_REVERSE"] = "ONLINE_REVERSE";
    WeavrAuthorizationTypesEnum["EXPIRED"] = "EXPIRED";
    WeavrAuthorizationTypesEnum["MANUAL_CLOSE"] = "MANUAL_CLOSE";
    WeavrAuthorizationTypesEnum["AUTHORISED_CREDIT"] = "AUTHORISED_CREDIT";
    WeavrAuthorizationTypesEnum["CANCELLED"] = "CANCELLED";
})(WeavrAuthorizationTypesEnum || (exports.WeavrAuthorizationTypesEnum = WeavrAuthorizationTypesEnum = {}));
